jQuery(document).ready(function ($) {
    var $btn = $('.backToTop');
    if (!$btn.length) return;

    var THRESHOLD = 300;
    var ticking = false;

    function update() {
        if ($(window).scrollTop() > THRESHOLD) {
            $btn.addClass('is-visible');
        } else {
            $btn.removeClass('is-visible');
        }
        ticking = false;
    }

    $(window).on('scroll resize', function () {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    });

    $btn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, 600, 'swing');
    });

    update();
});
